import React from 'react';

import {Drawer} from 'presentation/components/Drawer';
import {translations} from 'presentation/translations-new';
import {SortButtonsProps} from './types';
import {SortOrderType} from '../../../store/guideStore/types';

const {sortAtoZ, sortZtoA} = translations['pt-br'].privateFlow.guideFlow;
const {ordination} = translations['pt-br'].commons;

export function SortButtons({value, onChange}: SortButtonsProps) {
	const handleSortAsc = () => {
		const newOrder = value === SortOrderType.ASC ? SortOrderType.NONE : SortOrderType.ASC;
		onChange(newOrder);
	};

	const handleSortDesc = () => {
		const newOrder = value === SortOrderType.DESC ? SortOrderType.NONE : SortOrderType.DESC;
		onChange(newOrder);
	};

	const handleGetAllCategoryList = () => [
		{
			categoryTitle: ordination,
			categoryItemsList: [
				{
					active: value === SortOrderType.ASC,
					title: sortAtoZ,
					onClick: () => handleSortAsc(),
				},
				{
					active: value === SortOrderType.DESC,
					title: sortZtoA,
					onClick: () => handleSortDesc(),
				},
			],
		},
	];

	return (
		<Drawer.ContentListByCategory
			categoryList={handleGetAllCategoryList()}
			sx={{flex: 'none'}}
		/>
	);
}
